// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pinned-table {\n  box-shadow: 3px 0 6px -2px rgba(0, 0, 0, 0.15);\n}\n.draggable {\n  cursor: move; /* fallback if grab cursor is unsupported */\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n.draggable:hover .pin {\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
